/** Monthly, yearly, weekly and daily, in the order the toggle shows them. */
/** The tab next to the billing cycles that buys credits instead of a plan. */
export const TOP_UP_TAB = 'topup';

const INTERVAL_SORT_ORDER = ['month', 'year', 'week', 'day'];

export const billingCycleLabel = (
  interval: string,
  t: (key: string, fallback: string) => string
): string => {
  switch (interval.toLowerCase()) {
    case 'day':
      return t('DAILY', 'Daily');
    case 'week':
      return t('WEEKLY', 'Weekly');
    case 'month':
      return t('MONTHLY', 'Monthly');
    case 'year':
      return t('YEARLY', 'Yearly');
    case TOP_UP_TAB:
      return t('TOP_UP', 'Top up');
    default:
      return interval || '-';
  }
};

/** Each interval the catalogue sells, longest common first: month, year, week, day. */
export const uniquePlanIntervals = (prices: { interval: string }[] | undefined): string[] => {
  const seen = new Set<string>();
  const keys: string[] = [];
  for (const price of prices ?? []) {
    const key = price.interval.toLowerCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    keys.push(key);
  }
  return keys.sort((a, b) => {
    const ai = INTERVAL_SORT_ORDER.indexOf(a);
    const bi = INTERVAL_SORT_ORDER.indexOf(b);
    if (ai === -1 && bi === -1) return a.localeCompare(b);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
};
